import React from 'react';
import { AlertTriangle, Printer, CheckCircle } from 'lucide-react';

export const PrintGuidance: React.FC = () => {
  return (
    <div className="p-3 bg-muted/50 border border-border/50 rounded-lg space-y-2">
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <Printer className="w-3.5 h-3.5" />
        <h4 className="text-xs font-medium">Print Settings</h4>
      </div>
      
      <div className="space-y-1 text-xs text-muted-foreground">
        <div className="flex items-center gap-1.5">
          <CheckCircle className="w-3 h-3 text-success flex-shrink-0" />
          <span>Print at <strong className="text-foreground">100% / Actual Size</strong></span>
        </div>
        <div className="flex items-center gap-1.5">
          <AlertTriangle className="w-3 h-3 text-warning flex-shrink-0" />
          <span>Disable <strong className="text-foreground">"Fit to Page"</strong></span>
        </div>
        <div className="flex items-center gap-1.5">
          <CheckCircle className="w-3 h-3 text-success flex-shrink-0" />
          <span>Set margins to <strong className="text-foreground">None</strong></span>
        </div>
      </div>
      
      <p className="text-[10px] text-muted-foreground pt-1.5 border-t border-border/50">
        Label: 50.8 × 25.4 mm (2″ × 1″)
      </p>
    </div>
  );
};
